import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useState } from 'react';
import FieldsDialog from './FieldsDialog';
import { IoClose } from "react-icons/io5";
import { Box } from '@mui/material';


export default function CategoryDialog(props) {

    const [SelectedCategory, setSelectedCategory] = useState(null)
    const [OpenFieldsDialog, setOpenFiedsDialog] = useState(false)
    const [VisibleClose,SetVisibleClose]=useState(true)


    const handleOpenFieldsDialog = (row) => {
        setSelectedCategory(row)
        setOpenFiedsDialog(true)
    }

    const handleCloseFieldsDialog = () => {
        setOpenFiedsDialog(false)
    }


    return (
        <React.Fragment>
            <Dialog
                
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={OpenFieldsDialog ? "lg" : 'sm'}
                fullWidth
            >

                    <Box
                        sx={{
                            display: VisibleClose===false ? 'none' : 'block',
                            position: 'absolute',
                            top: 10,
                            right: 10,
                            cursor: 'pointer',
                            fontSize: '20px',
                        }}
                        onClick={props.handleClose}
                    >
                        <IoClose />
                    </Box>

                <DialogContent>
                    {
                        OpenFieldsDialog ?
                            <FieldsDialog userId={props.userId} handleClose={handleCloseFieldsDialog} category={SelectedCategory} ifsc_details={props.ifsc_details} SetVisibleClose={SetVisibleClose}/>
                            
                            :

                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 200 }} aria-label="simple table" size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Category</TableCell>
                                            <TableCell align='right'>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {props && props.productData?.categories.filter(item=>item.category_name.includes("mandate")===false).map((row) => (
                                            <TableRow
                                                key={row.category_id}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {row.category_display_name}
                                                </TableCell>
                                                <TableCell align="right"><Button variant='contained' color='secondary' onClick={() => handleOpenFieldsDialog(row)}>View</Button></TableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                    }

                </DialogContent>

            </Dialog>
        </React.Fragment>
    );
}
